import { createApp } from "vue";
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import { ServerTable } from "v-tables-3";

import App from "./App.vue";
import store from "./store";
import router from "./router";
import SoftUIDashboard from "./soft-ui-dashboard";

const appInstance = createApp(App);

appInstance.use(ServerTable, {}, "bootstrap4");

appInstance.use(store);
appInstance.use(router);
appInstance.use(SoftUIDashboard);
appInstance.mount("#app");
